import { USER_RECOVERY_RESET } from "../../redux/user/userConstants";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { makeStyles } from "@material-ui/core/styles";
import * as yup from "yup";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button/Button";
import { recovery } from "../../redux/user/userActions";
const validationSchema = yup.object().shape({
    mobileNumber: yup
        .string("شماره موبایل خود را وارد کنید")
        .required("شماره موبایل الزامی می باشد.")
        .matches(/^[0-9]+$/, "شماره موبایل تنها شامل اعداد است.")
        .min(11, "شماره موبایل شامل 11 رقم می باشد.")
        .max(11, " شماره موبایل شامل 11 رقم می باشد."),
});
const useStyles = makeStyles(() => ({
    label: {
        lineHeight: "42px",
        fontSize: "15px",
        fontWeight: "bold",
    },
    btn: {
        background: "#28A504",
        borderRadius: "10px",
        minWidth: "190px",
        boxShadow: "none",
    },
}));
export const Recovery = (props) => {
    const [recoveryValue, setRecoveryValue] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const classes = useStyles();
    const dispatch = useDispatch();
    const userRecovery = useSelector((state) => state.userRecovery);
    const { recoveryData } = userRecovery;
    useEffect(() => {
        if (recoveryData) {
            if (recoveryData.status === "ok") {
                props.success("اطلاعات با موفقیت ارسال شد.");
                dispatch({ type: USER_RECOVERY_RESET });
            }
            if (recoveryData.status === "error") {
                switch (recoveryData.message) {
                    case "UserIsBlocked":
                        props.failed(
                            "اکانت شما مسدود شده است لطفا به پشتیبانی مراجعه کنید"
                        );
                    default:
                        props.failed(" شماره موبایل شما اشتباه میباشد.");
                }
                dispatch({ type: USER_RECOVERY_RESET });
            }
        }
    }, [recoveryData]);
    return (
        <Box px={2} py={2}>
            <Box textAlign="center" fontSize="15px">
                <img
                    width="25px"
                    style={{ marginBottom: "-5px" }}
                    className="warn"
                    src="/images/warning.png"
                />
        &nbsp; اطلاعات به شماره موبایل ثبت شده پیامک میشود.
      </Box>
            <Formik
                style={{ width: "100%" }}
                initialValues={{
                    mobileNumber: "",
                }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    setLoading(true);
                    dispatch(recovery(values)).then(() => {
                        setLoading(false);
                    });
                }}
                render={({ handleSubmit, handleChange, values, touched, errors }) => (
                    <form onSubmit={handleSubmit}>
                        <Box px={1} mt={1}>
                            <label className={classes.label}>شماره تلفن همراه</label>
                            <TextField
                                fullWidth
                                name="mobileNumber"
                                variant="outlined"
                                value={values.mobileNumber}
                                onChange={handleChange}
                                error={touched.mobileNumber && Boolean(errors.mobileNumber)}
                                helperText={touched.mobileNumber && errors.mobileNumber}
                            />
                            <Box mt={4} textAlign="center">
                                <Button
                                    disabled={loading}
                                    variant="contained"
                                    className={classes.btn}
                                    color="secondary"
                                    type="submit"
                                >
                                    {loading ? <CircularProgress /> : "ارسال اطلاعات"}
                                </Button>
                            </Box>
                        </Box>
                    </form>
                )}
            />
        </Box>
    );
};
